import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { getAllSectorSlugs } from '../features/landing/data/sectors';

const Home = lazy(() => import('../features/landing/pages/Home'));
const BusinessList = lazy(() => import('../features/profile/pages/BusinessList'));
const Contact = lazy(() => import('../features/landing/pages/Contact'));
const BookingSearch = lazy(() => import('../features/booking/pages/BookingSearch'));
const DemoRequest = lazy(() => import('../features/landing/pages/DemoRequest'));
const BookingSuccess = lazy(() => import('../features/booking/pages/BookingSuccess'));
const BookingCreate = lazy(() => import('../features/booking/pages/BookingCreate'));
const BookingDetails = lazy(() => import('../features/booking/pages/BookingDetails'));
const BusinessProfile = lazy(() => import('../features/profile/pages/BusinessProfile'));
const SectorLanding = lazy(() => import('../features/landing/pages/SectorLanding'));
const NotFound = lazy(() => import('../features/shared/pages/NotFound'));
const GizlilikPolitikasi = lazy(() => import('../pages/GizlilikPolitikasi'));
const KullanimKosullari = lazy(() => import('../pages/KullanimKosullari'));
const KvkkAydinlatmaMetni = lazy(() => import('../pages/KvkkAydinlatmaMetni'));
const CerezPolitikasi = lazy(() => import('../pages/CerezPolitikasi'));
const IptalIadeKosullari = lazy(() => import('../pages/IptalIadeKosullari'));

// Sektör route'larını dinamik oluştur (/:slug'dan önce gelmeli)
const sectorRoutes = getAllSectorSlugs().map((slug) => ({
  path: `/${slug}`,
  element: <SectorLanding />,
}));

export const trRoutes = [
  { path: '/', element: <Home /> },
  { path: '/hizmetler', element: <BusinessList /> },
  { path: '/isletmeler', element: <BusinessList /> },
  { path: '/fiyatlar', element: <Navigate to="/iletisim" replace /> },
  { path: '/gizlilik-politikasi', element: <GizlilikPolitikasi /> },
  { path: '/kullanim-kosullari', element: <KullanimKosullari /> },
  { path: '/kvkk-aydinlatma-metni', element: <KvkkAydinlatmaMetni /> },
  { path: '/cerez-politikasi', element: <CerezPolitikasi /> },
  { path: '/iptal-iade-kosullari', element: <IptalIadeKosullari /> },
  { path: '/iletisim', element: <Contact /> },
  { path: '/randevu-sorgula', element: <BookingSearch /> },
  { path: '/demo-talebi', element: <DemoRequest /> },
  { path: '/basarili', element: <BookingSuccess /> },
  // Sektör landing page'leri — /:slug'dan önce tanımlanmalı
  ...sectorRoutes,
  { path: '/:slug/randevu', element: <BookingCreate /> },
  { path: '/randevu/:code', element: <BookingDetails /> },
  { path: '/:slug', element: <BusinessProfile /> },
  { path: '/404', element: <NotFound /> },
  { path: '*', element: <NotFound /> }
];

export default trRoutes;
